import { wrapReducer } from "@client/content/lib/helper";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type InitSuccessActionData } from "./actions";
import { type BlogDetailContent } from "./types";

export const defaultState: BlogDetailContent.State = {
  id: "",
  status: "None",
  content: null
};

export const previewState: BlogDetailContent.State = {
  id: "",
  status: "Ready",
  content: ""
};

const reducer = (state: BlogDetailContent.State, action: ReduxAction<any>): BlogDetailContent.State => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: Status.Loading
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const { content } = action.data as InitSuccessActionData;
      return {
        ...state,
        content,
        status: Status.Ready
      };
    }

    default:
      return state;
  }
};

export default wrapReducer<BlogDetailContent.State>({ defaultState, reducer, previewState });
